export default "__VITE_ASSET__C4Ugh9Pe__"